import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../Constant";

export default class Domains extends Component {
  state = {
    data :[],
    columns : [
      {
        name: "Domain Name",
        selector: "fullName",
        sortable: true,
      },
      {
        name: "Registration",
        selector: "createdAt",
        sortable: true,
        right: true,
      },
      // {
      //   name: "Last Login",
      //   selector: "updatedAt",
      //   sortable: true,
      //   right: true,
      // },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        right: true,
        cell: (row) => (
          <div className="d-flex">
          <i
            class="btn btn-light shadow-sm mx-1 fas fa-times text-danger"
            id={row.id}
            onClick={this.deleteDomain}
          ></i>
          {/* <Link to={`/admin/user/${row.id}`}>
            <i
              class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
              id={row.id}
            ></i>
          </Link> */}
        </div>
        ),
      },
    ]
  }
  componentDidMount() {
    this.getDomains();
  }
  getDomains = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    // urlencoded.append("siteId", "01650163-d417-4850-a9b6-42eb646eddec");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/site/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
            data[i].fullName = data[i].name
          console.log(data[i]);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
          }-${date.getUTCFullYear()}`;
          data[i].updatedAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
          }-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  deleteDomain = (e) => {
    var siteId = e.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", siteId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/site/delete", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        document.location.reload();
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    return (
      <div className="py-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /<b> Domains</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                <Link
                  to="/admin/add-domain/"
                  className="btn btn-dark float-right"
                >
                  Add Domain
                </Link>
                {/* <Link to="/admin/add-user" className="btn btn-dark float-right">Add User</Link> */}
              </div>
            </div>
          </div>

          <div className="users-container p-2">
            <DataTable
              noHeader={true}
              columns={this.state.columns}
              data={this.state.data}
              theme="solarized"
            />
          </div>
        </div>
      </div>
    );
  }
}
